export const pointsPerHint = 10
export const contaminationCriticalActionIds = new Set(['MaintainSterility'])
export const pointsPerContamination = 30
export const bladderScanCriticalActionIds = new Set(['CaptureScan1', 'CaptureScan2'])
export const pointsPerFailedBladderScan = 20
